import React from "react";
import {  useSelector } from "react-redux";
import AnswerBlockHeader from "./AnswerBlockHeader";
import AnswerBlock from "./AnswerBlock";
import Loader from "../loader";

const SelectedAnswersContainer = ({ handleViewMore }) => {
  const { attemptedQuestions, moreQuestions, newQuestionAPI } = useSelector(
    (state) => state.data,
  );

  return (
    <div
      className="border-b py-2 px-6 h-[7.5rem] overflow-x-auto sticky top-0 z-10 bg-white"
      role="region"
      aria-label="Attempted questions"
    >
      <div className="w-full flex flex-nowrap items-start">
        {attemptedQuestions.map((question) => (
          <React.Fragment key={question.questionId}>
            <div className="min-w-fit relative pr-2 pl-2">
              <div className="">
                <AnswerBlockHeader question={question} />
                <AnswerBlock data={question} answerText={question.answer} />
              </div>
            </div>
            {attemptedQuestions.length - 1 ? (
              <div
                className="border-l border-dashed border-border self-stretch mr-4 ml-4"
                aria-hidden="true"
              />
            ) : null}
          </React.Fragment>
        ))}
        {attemptedQuestions.length > 2 && attemptedQuestions.length < 6 && (
          <>
            {moreQuestions ? (
              newQuestionAPI.status === "loading" ? (
                <Loader
                  className="my-auto"
                  aria-busy="true"
                  aria-label="Loading more questions"
                />
              ) : (
                <button
                  onClick={handleViewMore}
                  className="bg-primary hover:bg-primary-hover my-auto text-white p-4 rounded-lg text-sm font-semibold transition-all shadow-lg active:scale-95"
                  aria-label="Answer more questions"
                >
                  Answer More Questions
                </button>
              )
            ) : null}
          </>
        )}
      </div>
    </div>
  );
};

export default SelectedAnswersContainer;
